import React, { useContext } from 'react';
import CaseScheduleContext from '../case-schedule/case-schedule-context';
import { blue } from '../../theme';

const payerIcon = (
  <svg
    width="64"
    height="64"
    style={{ minWidth: '64px', minHeight: '64px' }}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 4a4 4 0 0 1 4-4h56a4 4 0 0 1 4 4v56a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4Zm32.195 1.333L9.337 12.952v22.857c0 12.625 10.233 22.857 22.858 22.857S55.052 48.434 55.052 35.81V12.952l-22.857-7.62Zm.001 49.048c10.256 0 18.572-8.316 18.572-18.572V16.166L32.196 9.62l-18.571 6.547V35.81c0 10.256 8.316 18.572 18.571 18.572Z"
      fill="#00A0FF"
    />
  </svg>
);

const PayerCard = (props) => {
  const { selectedPayer } = props;
  let readOnlyMode = false;
  const context = useContext(CaseScheduleContext);
  if (context) {
    readOnlyMode = context.readOnlyMode;
  }
  let payerWebsite = '';
  if (selectedPayer.website) {
    payerWebsite = selectedPayer.website.indexOf('://') === -1
      ? `http://${selectedPayer.website}`
      : selectedPayer.website;
  }

  let payerAddressUrl = '';
  if (selectedPayer.address) {
    const {
      streetAddress1 = '',
      city = '',
      state = '',
      zip = ''
    } = selectedPayer.address;
    const tmpAddress = `${streetAddress1} ${city} ${state}`;
    // const addressUrl = 'https://www.google.com/maps/search/?api=1&query=' + encodeURI(`${addTmp.join(' ')} ${zip.substr(0, 5)}`);
    payerAddressUrl = 'https://www.google.com/maps/search/?api=1&query=' + encodeURI(`${tmpAddress} ${zip.substr(0, 5)}`);
  }

  let payerPhoneUrl = '';
  if (selectedPayer.phone) {
    const tmp = selectedPayer.phone.replace(/-/g, '');
    payerPhoneUrl = `tel:+1${tmp}`;
  }

  // Anonymous payer card
  if (selectedPayer.id === '632b3f6070289c1efc119171' || selectedPayer._id === '632b3f6070289c1efc119171') {
    return (
      <div
        className='p-2 mt-2'
        style={{
          background: blue[700],
          borderRadius: '4px',
          height: '191px',
          display: Object.keys(selectedPayer).length === 0 ? 'none' : ''
        }}
      >
        {/* Header */}
        <div className='fx'>
          {/* Header Icon */}
          <div
            style={{
              width: '64px',
              flexGrow: '0',
              flexShrink: '0'
            }}
          >
            {payerIcon}
          </div>
          {/* Header Text */}
          <div
            className='ml-2'
            style={{ flexGrow: '1' }}
          >
            <div>{selectedPayer.payerName.replaceAll('"', '')}</div>
          </div>
          {/* Delete Button */}
          <div
            className='ml-2'
            style={{
              width: '16px',
              flexGrow: '0',
              flexShrink: '0'
            }}
            onClick={() => {
              if (props.showEllipsis) {
                props.onClickOnEllipsis();
              } else {
                props.onDelete();
              }
            }}
          >
            {!props.showEllipsis
              ? <i className='fa fa-trash' />
              : <i className='fa fa-ellipsis-h' />
            }
          </div>
        </div>
        {/* Message */}
        <div className='mt-1'>
          This payer is not in the payer database. Please contact MedPros to have this payer added.
        </div>
      </div>
    );
  }

  return (
    <div
      className='p-2 mt-2'
      style={{
        ...props.style,
        background: blue[700],
        borderRadius: '4px',
        height: '191px',
        display: Object.keys(selectedPayer).length === 0 ? 'none' : ''
      }}
    >
      {/* Header */}
      <div className='fx'>
        {/* Header Icon */}
        <div
          style={{
            width: '64px',
            flexGrow: '0',
            flexShrink: '0'
          }}
        >
          {selectedPayer.avatarImageUrl
            ? <img
              src={selectedPayer.avatarImageUrl}
              style={{
                height: '64px',
                width: '64px',
                borderRadius: '10px'
              }}
            />
            : payerIcon
          }
        </div>
        {/* Header Text */}
        <div
          className='ml-2 line-clamp'
          style={{ flexGrow: '1' }}
        >
          <div>{selectedPayer.payerName}</div>
          {selectedPayer.userName && selectedPayer.userName.length > 0 &&
            <div style={{ color: blue[500] }}>
              @{selectedPayer.userName}
            </div>
          }
        </div>
        {/* Ellipsis / Delete Button */}
        <div
          className='ml-2'
          style={{
            width: '16px',
            flexGrow: '0',
            flexShrink: '0'
          }}
          onClick={() => {
            if (!readOnlyMode) {
              if (props.showEllipsis) {
                props.onClickOnEllipsis();
              } else {
                props.onDelete();
              }
            }
          }}
        >
          {!props.showEllipsis
            ? <i className='fa fa-trash' />
            : <i className='fa fa-ellipsis-h' />
          }
        </div>
      </div>
      {/* Address, Phone and Website */}
      <div className='mt-1'>
        {/* Address */}
        <div className='fx'>
          {/* Icon */}
          <div>
            <svg
              width="18"
              height="21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.263 4.862a8.149 8.149 0 0 0-1.975-2.535A9.39 9.39 0 0 0 12.422.624 9.659 9.659 0 0 0 9.002 0h-.004c-1.17 0-2.32.21-3.42.624a9.39 9.39 0 0 0-2.866 1.703A8.14 8.14 0 0 0 .737 4.862 7.003 7.003 0 0 0 0 7.978c0 1.497.364 3.035 1.083 4.574.594 1.273 1.435 2.557 2.502 3.819 1.908 2.257 4.056 3.873 4.89 4.461a.905.905 0 0 0 1.05 0c.834-.588 2.984-2.204 4.89-4.461 1.064-1.262 1.908-2.546 2.502-3.82C17.636 11.014 18 9.473 18 7.979a6.996 6.996 0 0 0-.737-3.116Zm-8.264.687c-1.659 0-3.007 1.361-3.007 3.037S7.34 11.623 9 11.623c1.66 0 3.007-1.361 3.007-3.037S10.658 5.55 8.999 5.55Zm0 7.734a4.599 4.599 0 0 0 3.291-1.376 4.693 4.693 0 0 0 1.362-3.323A4.693 4.693 0 0 0 12.29 5.26 4.607 4.607 0 0 0 9 3.885 4.599 4.599 0 0 0 5.71 5.26a4.696 4.696 0 0 0-1.362 3.324c0 1.257.484 2.437 1.361 3.323A4.603 4.603 0 0 0 9 13.283Z"
                fill="#96C8FF"
              />
            </svg>
          </div>
          {/* Text */}
          <div
            className='ml-2'
            style={{ marginTop: '-2px', fontSize: '14px' }}
          >
            {selectedPayer.address
              ? <>
                <a
                  target="_blank"
                  href={payerAddressUrl}
                  rel="noreferrer"
                >
                  <div>
                    {selectedPayer.address && selectedPayer.address.streetAddress1
                      ? selectedPayer.address.streetAddress1
                      : ''
                    }
                  </div>
                  <div>
                    {selectedPayer.address && selectedPayer.address.city
                      ? selectedPayer.address.city
                      : ''
                    },&nbsp;
                    {selectedPayer.address && selectedPayer.address.state
                      ? selectedPayer.address.state
                      : ''
                    }&nbsp;
                    {selectedPayer.address && selectedPayer.address.zip
                      ? selectedPayer.address.zip
                      : ''
                    }
                  </div>
                </a>
              </>
              : ''
            }
          </div>
        </div>
        {/* Phone */}
        <div className='fx mt-2'>
          {/* Icon */}
          <div>
            <svg
              width="21"
              height="20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.89 4.485c.163.375.295.766.39 1.166 1.61.491 2.724 2.011 2.727 3.735a3.877 3.877 0 0 1-1.146 2.757c-.4.402-.866.706-1.384.9a7.238 7.238 0 0 1-.585 2.472 7.294 7.294 0 0 1-1.616 2.337 7.5 7.5 0 0 1-2.391 1.572 7.582 7.582 0 0 1-2.811.576h-.116a2.578 2.578 0 0 1-1.802-.777 2.577 2.577 0 0 1-.746-1.82c0-.692.27-1.344.761-1.835a2.579 2.579 0 0 1 1.836-.761h.067c.667.018 1.295.29 1.768.766a2.588 2.588 0 0 1 .721 2.261 5.877 5.877 0 0 0 1.603-1.116 5.658 5.658 0 0 0 1.733-4.075V7.357a5.658 5.658 0 0 0-1.733-4.075 6.004 6.004 0 0 0-4.21-1.697c-1.59 0-3.086.603-4.211 1.7a5.658 5.658 0 0 0-1.733 4.074l.034 5.07a.779.779 0 0 1-.228.563.787.787 0 0 1-.728.218 3.873 3.873 0 0 1-1.945-1.062A3.886 3.886 0 0 1 0 9.388C0 8.533.268 7.72.775 7.04a3.846 3.846 0 0 1 1.853-1.36 7.295 7.295 0 0 1 2.016-3.532A7.502 7.502 0 0 1 7.035.576 7.655 7.655 0 0 1 9.958 0c1.011 0 1.996.194 2.924.576.896.37 1.702.9 2.392 1.572a7.308 7.308 0 0 1 1.616 2.337ZM.395 10.641Zm.222.496c.054.069.11.138.167.205-.057-.067-.113-.134-.167-.205Zm1.813.034a2.305 2.305 0 0 1-.844-1.784c0-.413.107-.82.308-1.174.138-.246.322-.462.536-.639v3.597Zm.2.393.084.083a1.416 1.416 0 0 1-.167-.167l.083.084Zm.147-5.745c.052-.096.11-.192.167-.288a2.73 2.73 0 0 0-.167.288Zm.125 7.161a2.102 2.102 0 0 0 .068.047l-.068-.046Zm1.093-.517v-.033c.01.01.01.022 0 .033ZM5.43 1.706c.043-.033.085-.067.129-.099a3.59 3.59 0 0 0-.13.099Zm.129-.099ZM7.154.721a4.88 4.88 0 0 0 .052-.02l-.052.02Zm1.276.997.058-.058a1.41 1.41 0 0 1 .116-.11c-.037.038-.077.075-.116.112l-.058.056Zm6.719.557Zm.125.125-.125-.125c.042.04.085.083.125.125Zm.374.413ZM10.727 18.11a1.004 1.004 0 0 1-.688.306H9.99a1.012 1.012 0 1 1 .737-.306Zm.544-.735a.08.08 0 0 1-.008-.03c.017.02.017.04.017.06 0-.01-.004-.02-.009-.03Zm1.117.812.083-.053a1.934 1.934 0 0 1-.166.106l.083-.053Zm2.668-.375.092-.088c.042-.04.085-.083.125-.125l-.125.125-.136.13c.014-.015.029-.029.044-.042Zm1.048-10.586c0 .02.004.043.008.064a.348.348 0 0 1 .008.065c0-.042 0-.087-.016-.13Zm.622 8.215Zm0 0a2.539 2.539 0 0 0 .024-.057l-.024.057ZM16.578 4.24Zm.148.317c.022.05.044.1.062.152-.02-.051-.04-.103-.063-.152Zm.372 1.1.166.166-.083-.083a9.59 9.59 0 0 0-.083-.084Zm.767 5.495Zm-.128-.127c-.08.08-.163.152-.253.219v-3.74c.24.179.445.404.601.667.219.367.333.786.333 1.217a2.29 2.29 0 0 1-.681 1.637Zm2.002-2.75.049.052c-.056-.057-.111-.113-.167-.167.044.038.081.077.118.116Zm-.29-.535a2.78 2.78 0 0 1 .067.067l-.067-.067Zm.116.115.05.052-.037-.039-.013-.013Zm.188 2.644c-.043.044-.086.09-.134.133l-.002.002.002-.002c.06-.054.12-.108.165-.165l-.03.032Z"
                fill="#96C8FF"
              />
            </svg>
          </div>
          {/* Text */}
          <div
            className='ml-2'
            style={{ marginTop: '-2px', fontSize: '14px' }}
          >
            <a href={payerPhoneUrl}>
              {selectedPayer.phone || ''}
            </a>
          </div>
        </div>
        {/* Website */}
        <div className='fx mt-2'>
          {/* Icon */}
          <div>
            <svg
              width="20"
              height="20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 10C0 4.48 4.379 0 9.786 0c5.417 0 9.806 4.48 9.806 10s-4.389 10-9.806 10C4.38 20 0 15.52 0 10Zm13.684-3.999h2.89a7.904 7.904 0 0 0-4.242-3.56 15.846 15.846 0 0 1 1.352 3.56ZM9.797 2.04c.813 1.2 1.45 2.53 1.87 3.96H7.927a14.214 14.214 0 0 1 1.87-3.96ZM1.96 10c0 .69.098 1.36.255 2h3.31c-.078-.66-.136-1.32-.136-2 0-.68.058-1.34.137-2H2.216a8.404 8.404 0 0 0-.255 2Zm1.055 4h2.89c.313 1.25.764 2.45 1.351 3.56A7.862 7.862 0 0 1 3.016 14Zm0-7.999h2.89c.313-1.25.764-2.45 1.351-3.56a7.862 7.862 0 0 0-4.241 3.56Zm6.78 11.959c-.812-1.2-1.449-2.53-1.87-3.96h3.742a14.212 14.212 0 0 1-1.871 3.96ZM7.505 12h4.585c.088-.66.157-1.32.157-2 0-.68-.069-1.35-.157-2H7.504c-.088.65-.156 1.32-.156 2 0 .68.068 1.34.156 2Zm4.828 5.56A15.846 15.846 0 0 0 13.684 14h2.89a7.904 7.904 0 0 1-4.242 3.56ZM14.203 10c0 .68-.058 1.34-.137 2h3.311a8.4 8.4 0 0 0 .255-2 8.4 8.4 0 0 0-.255-2h-3.31c.078.66.136 1.32.136 2Z"
                fill="#96C8FF"
              />
            </svg>
          </div>
          {/* Text */}
          <div
            className='ml-2 text-truncate'
            style={{ marginTop: '-2px', fontSize: '14px' }}
          >
            <div>
              <a
                href={payerWebsite}
                target='_blank'
                rel="noreferrer"
              >
                {payerWebsite}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

PayerCard.defaultProps = {
  showEllipsis: false,
  style: {}
};

export default PayerCard;
